export function safeGoogleMapsUrl(value) {
  try {
    const url = new URL(value);
    const allowed = ['maps.app.goo.gl', 'goo.gl', 'maps.google.com', 'www.google.com', 'google.com'];
    if (url.protocol !== 'https:' || !allowed.includes(url.hostname) || url.username || url.password) return '';
    if (url.hostname === 'goo.gl' && !url.pathname.startsWith('/maps')) return '';
    if (['www.google.com', 'google.com'].includes(url.hostname) && !url.pathname.startsWith('/maps')) return '';
    return url.href;
  } catch (_) { return ''; }
}
export function orderLocation(order) {
  const lat = order.customCemeteryLatitude;
  const lng = order.customCemeteryLongitude;
  const hasCoordinates = typeof lat === 'number' && typeof lng === 'number' && Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
  return {
    city: order.customCityName || order.cityName || order.cityId || '—',
    cemetery: order.customCemeteryName || order.cemeteryName || order.cemetery?.name || order.cemeteryId || '—',
    address: order.customCemeteryAddress || '',
    url: safeGoogleMapsUrl(order.customCemeteryGoogleMapsUrl) || (hasCoordinates ? 'https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lng : ''),
    coordinates: hasCoordinates ? lat + ', ' + lng : '',
  };
}
